/* eslint-disable */
/**
 * SPA
 * API serving data for the SPA
 *
 * The version of the OpenAPI document is present in runtime.ts
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Message } from './Message';
import {
    MessageFromJSON,
    MessageFromJSONTyped,
    MessageToJSON,
} from './Message';
import type { PayloadTypeConstants } from './PayloadTypeConstants';
import {
    PayloadTypeConstantsFromJSON,
    PayloadTypeConstantsFromJSONTyped,
    PayloadTypeConstantsToJSON,
} from './PayloadTypeConstants';

/**
 * 
 * @export
 * @interface GenericResponse
 */
export interface GenericResponse {
    /**
     * 
     * @type {PayloadTypeConstants}
     * @memberof GenericResponse
     */
    type: PayloadTypeConstants;
    /**
     * 
     * @type {Array<Message>}
     * @memberof GenericResponse
     */
    messages: Array<Message>;
    /**
     * 
     * @type {string}
     * @memberof GenericResponse
     */
    openInNewWindowUri?: string;
    /**
     * 
     * @type {any}
     * @memberof GenericResponse
     */
    payload?: any;
}

/**
 * Check if a given object implements the GenericResponse interface.
 */
export function instanceOfGenericResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "messages" in value;

    return isInstance;
}

export function GenericResponseFromJSON(json: any): GenericResponse {
    return GenericResponseFromJSONTyped(json, false);
}

export function GenericResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GenericResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': PayloadTypeConstantsFromJSON(json['type']),
        'messages': ((json['messages'] as Array<any>).map(MessageFromJSON)),
        'openInNewWindowUri': !exists(json, 'openInNewWindowUri') ? undefined : json['openInNewWindowUri'],
        'payload': !exists(json, 'payload') ? undefined : json['payload'],
    };
}

export function GenericResponseToJSON(value?: GenericResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': PayloadTypeConstantsToJSON(value.type),
        'messages': ((value.messages as Array<any>).map(MessageToJSON)),
        'openInNewWindowUri': value.openInNewWindowUri,
        'payload': value.payload,
    };
}

